import configuratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import { actions } from './Actions';

export default function (state, action) {
  switch (action.type) {
    case actions.TOOGLE_SHOW_CONFLICTS_ALERT: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration.customdata,
            showConflictsAlert: action.flag,
          },
        },
      };
    }
    case actions.SET_CUSTOM_DATA: {
      let customDataSubOptions = state.configuration.customdata.selectedSubOptions;
      if (
        customDataSubOptions &&
        customDataSubOptions.length > 0 &&
        action.data &&
        action.data.optionclassificationIdentifier &&
        action.data.amount
      ) {
        if (
          customDataSubOptions.findIndex(
            (so) =>
              so.optionclassificationIdentifier === action.data.optionclassificationIdentifier &&
              so.optionIdentifier === action.data.optionIdentifier
          ) !== -1
        ) {
          customDataSubOptions = customDataSubOptions.map((so) => {
            if (
              so.optionclassificationIdentifier === action.data.optionclassificationIdentifier &&
              so.optionIdentifier === action.data.optionIdentifier
            ) {
              return { ...so, subOption: action.data.subOption };
            }
            return so;
          });
        } else {
          customDataSubOptions = [...customDataSubOptions, action.data];
        }
      }
      if (!action.data.amount && customDataSubOptions && customDataSubOptions.length > 0) {
        const index = customDataSubOptions.findIndex(
          (op) =>
            op.optionIdentifier === action.data.optionIdentifier &&
            op.optionclassificationIdentifier === action.data.optionclassificationIdentifier &&
            op.subOption.identifier === action.data.subOption.identifier
        );
        index !== -1 && customDataSubOptions.splice(index, 1);
      }
      if (action.data.amount && customDataSubOptions && customDataSubOptions.length === 0) {
        customDataSubOptions = [action.data];
      }
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration.customdata,
            selectedSubOptions: customDataSubOptions ? customDataSubOptions : [action.data],
          },
        },
      };
    }
    case actions.SET_CUSTOM_COLOR: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration.customdata,
            aussenlackierung: action.data,
          },
        },
      };
    }
  }
  return configuratorReducer(state, action);
}
